import { render, staticRenderFns } from "./ServiceSupplementAmounts.vue?vue&type=template&id=be933920"
import script from "./ServiceSupplementAmounts.vue?vue&type=script&lang=js"
export * from "./ServiceSupplementAmounts.vue?vue&type=script&lang=js"
import style0 from "./ServiceSupplementAmounts.vue?vue&type=style&index=0&id=be933920&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports